module.exports = __webpack_public_path__ + "img/monero.247f35a5.svg";